export class SharedUtils {
  static dataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',');
    if (splitDataURI[0] && splitDataURI[1]) {
      const byteString =
        splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
      const splitMime = splitDataURI[0].split(':');
      const mimeString = splitMime[1] ? splitMime[1].split(';')[0] : '';

      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

      return new Blob([ia], { type: mimeString });
    } else {
      throw new Error('Invalid data URI');
    }
  }

  static sortBy(field: string) {
    return function (a: any, b: any) {
      if (a[field] == null && b[field] == null) return 0;
      if (a[field] == null) return -1;
      if (b[field] == null) return 1;

      return (a[field] < b[field] ? 1 : 0) - (a[field] > b[field] ? 1 : 0);
    };
  }
}

export abstract class EnvHelper {
  public static getWebEnv(): string {
    let activeEnvironment = null;
    const url = window.location.host;
    const domain = url.split('.')?.[0]?.split(':')[0];

    if (domain === 'localhost') {
      return 'local';
    }

    const env = url.split('.')?.[1]?.split(':')[0];
    if (env === 'localhost') {
      return 'local';
    }

    const possibleEnvironments = ['dev', 'int', 'staging'];
    const foundEnvironments = possibleEnvironments.filter(
      (e) => env === e || url.includes(`.${e}.`)
    );

    if (foundEnvironments.length > 0 && foundEnvironments[0]) {
      activeEnvironment = foundEnvironments[0];
    }
    return activeEnvironment || 'production';
  }

  public static getEmbedLibEnv(embedLibUrl: string): string {
    let activeEnvironment = null;
    const url = embedLibUrl;
    const domain = url.split('//')?.[1]?.split('.')?.[0]?.split(':')[0];
    if (domain === 'localhost') {
      return 'local';
    }

    const env = url.split('.')?.[1]?.split(':')[0];
    if (env === 'localhost') {
      return 'local';
    }

    const possibleEnvironments = ['dev', 'int', 'staging'];
    const foundEnvironments = possibleEnvironments.filter(
      (e) => env === e || url.includes(`.${e}.`)
    );

    if (foundEnvironments.length > 0 && foundEnvironments[0]) {
      activeEnvironment = foundEnvironments[0];
    }
    return activeEnvironment || 'production';
  }
}
